import Layout from '@/components/feature/Layout';
import QuoteEngine from '@/pages/home/components/QuoteEngine';

export default function QuotePage() {
  return (
    <Layout>
      <QuoteEngine />
    </Layout>
  );
}